// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".condition-button[data-v-4c2db2e4]{text-align:center;background-color:#fff;color:#333;cursor:pointer;padding:6px 10px;border-radius:6px;font-weight:700;border:1px solid #ccc;font-size:12px;outline:none}.condition-button[data-applied=true][data-v-4c2db2e4]{background-color:#ff6c5b;color:#fff}", ""]);
// Exports
module.exports = exports;
